"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnDeleted = void 0;
var OnDeleted = /** @class */ (function (_super) {
    __extends(OnDeleted, _super);
    function OnDeleted() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._typeName = "OnDeleted";
        _this.id = function () {
            _this.push(function (_) { return "id"; });
        };
        _this.identityId = function () {
            _this.push(function (_) { return "identityId"; });
        };
        _this.reference = function () {
            _this.push(function (_) { return "reference"; });
        };
        _this.type = function () {
            _this.push(function (_) { return "type"; });
        };
        _this.render = function (registry) { return _this.map(function (e) { return e(registry); }).join(" "); };
        return _this;
    }
    return OnDeleted;
}(Array));
exports.OnDeleted = OnDeleted;
//# sourceMappingURL=OnDeleted.js.map